<template>
  <div>
    <base-header
      type="gradient-info"
      class="pb-6 pb-8 pt-5 pt-md-6"
    ></base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-xl-12">
          <card shadow>
            <div slot="header" class="bg-transparent border-0">
              <div class="row align-items-center">
                <div class="col-1">
                  <base-button
                    type="primary"
                    size="sm"
                    @click="$router.back()"
                    ><i class="ni ni-bold-left mt-1"></i
                  ></base-button>
                </div>
                <div class="col-8">
                  <h3 class="mb-0">{{ $t("term_condition_by_company") }}</h3>
                </div>
              </div>
            </div>
            <template>
              <FormCompany :company="$route.params.id ? $route.params.id : null" />
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormCompany from "./Form/createdOrUpdate.vue";
export default {
  components: {
    FormCompany,
  },
};
</script>